<template>
  <el-row class="core_one_wrap">
    <el-col class="one_left">
      <div class="left_tit">
        AI、智能体与知识库的深度融合，构建了“感知-决策-行动”闭环的智能系统
      </div>
      <ul class="left_desc">
        <li>AI大模型提供基础语义理解与推理能力（如GPT、DeepSeek），支持自然语言交互与复杂任务拆解</li>
        <li>智能体作为执行中枢，通过感知环境（文本、图像、传感器数据）、调用知识库信息、规划行动路径（如AutoGPT任务分解、特斯拉自动驾驶路径规划），实现从决策到执行的闭环</li>
        <li>知识库以结构化或非结构化形式存储领域知识（如医疗诊断规则、企业产品手册），通过RAG（检索增强生成）技术动态增强AI回答的准确性与专业性</li>
      </ul>
      <div class="left_card">
        <div class="card_item" v-for="(item, index) in cardList" :key="index">
          <i :class="item.icon" class="iconfont"></i>
          <span class="item_txt">{{ item.txt }}</span>
        </div>
      </div>
    </el-col>
    <el-col class="one_right">
      <img src="@/assets/img/right1.png" alt="">
    </el-col>
  </el-row>
</template>

<script>
export default {
  data() {
    return {
      cardList: [
        {
          icon: 'icon-chanyelian-shengwuyiyao',
          txt: '智能体',
        },
        {
          icon: 'icon-shengchanzhizao',
          txt: '工作流',
        },
        {
          icon: 'icon-lvye',
          txt: ' 隐私计算',
        },
        {
          icon: 'icon-zu',
          txt: ' 智能硬件',
        },
        {
          icon: 'icon-dc-icon-xinxijishu',
          txt: '增强现实(AR)',
        },
        {
          icon: 'icon-fenzishi',
          txt: '虚拟现实(VR)',
        },
        // {
        //   icon: 'icon-fenzishi',
        //   txt: '科技服务业务',
        // },
        // {
        //   icon: 'icon-xinnengyuan',
        //   txt: '新能源汽车',
        // },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.core_one_wrap {
  display: flex;
  justify-content: center;
  text-align: left;
  margin-bottom: 30px;
  @media screen and (max-width: 768px) {
    flex-wrap: wrap;
  }
  .one_left {
    width: 40%;
    @media screen and (max-width: 768px) {
      width: 90%;
    }
    .left_tit {
      font-size: 23px;
      font-weight: bold;
      color: #3e3e3e;
      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
        margin-top: 20PX;
      }
    }

    .left_desc {
      color: #717171;
      padding: 10px 40px 20px 40px;
      li {
        line-height: 25PX;
      }
      @media screen and (max-width: 768px) {
        font-size: 14px;
      }
    }

    .left_card {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-top: 25px;
      margin-right: 80px;
      @media screen and (max-width: 768px) {
        margin: 0;
      }
      .card_item {
        box-sizing: border-box;
        width: 30%;
        height: 50px;
        background: #fff;
        box-shadow: 0 -0.0625rem 0.4375rem 0 silver,
          0 0 0.75rem 0 rgb(0 0 0 / 10%);
        display: flex;
        align-items: center;
        color: #0991d3;
        padding: 0 20px;
        cursor: pointer;
        @media screen and (max-width: 768px) {
          height: 50PX;
        }
        i{
          font-size: 1.3rem;
        }
        &:nth-child(n + 4) {
          margin-top: 30px;
          @media screen and (max-width: 768px) {
            margin-top: 16PX;
          }
        }
        &:hover .item_txt {
          letter-spacing: 4px;
        }
        .item_txt {
          width: 100%;
          font-weight: bold;
          font-size: 17px;
          margin-left: 10px;
          transition: all 1s;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          @media screen and (max-width: 768px) {
            font-size: 14px;
          }
        }
      }
    }
  }

  .one_right {
    width: 20%;
    height: 100%;
    @media screen and (max-width: 768px) {
      width: 70%;
      margin-top: 20PX;
    }
    img{
      width: 100%;
      margin-top: 40px;
    }
  }
}
</style>
